<script setup lang="ts">

import type NewsItem from "@/types/NewsItem.ts";
import NewsItemBaseStructure from '@/components/Sections/News/Types/Base/NewsItemBaseStructure.vue'
import NewsItemBase from '@/components/Sections/News/Types/Base/NewsItemBase.vue'
import { CDN } from '@/models/cdn.ts'
import PlayerName from '@/components/Objects/PlayerName.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/**
 * Props
 */
const props = defineProps<{
  newsItem: NewsItem,
  toast: boolean
}>();

</script>

<template>
  <NewsItemBase
    :toast="toast"
    :toast-image="CDN.spyDead(64,props.newsItem.contentData.imageCode)"
    :toast-text="t('news.types.spyAssassinated.title')"
  >
    <NewsItemBaseStructure
      :newsItem="props.newsItem"
      :item-image="CDN.spyDead(512,props.newsItem.contentData.imageCode)"
      :header="t('news.types.spyAssassinated.title')"
    >
      <div v-if="props.newsItem.contentData.targetPlayerId===0">
        <span class="text-metal-300">{{ props.newsItem.contentData.name }}</span> {{ t('news.types.spyAssassinated.bodyUnknown') }}
      </div>
      <div v-else>
        <span class="text-metal-300">{{ props.newsItem.contentData.name }}</span> {{ t('news.types.spyAssassinated.bodyKnown') }} <PlayerName :player-id="props.newsItem.contentData.targetPlayerId" />.
      </div>
    </NewsItemBaseStructure>
  </NewsItemBase>
</template>

<style scoped lang="scss">

</style>